window.UA = {
    platform: navigator.platform,
    ua: navigator.userAgent,
    appversion: navigator.appVersion,
    isIPod: navigator.userAgent.indexOf('ipod') > -1 ? true : false,
    isIPhone: navigator.userAgent.indexOf('iPhone') > -1 ? true : false,
    isIPad: navigator.userAgent.indexOf('iPad') > -1 ? true : false,
    isADevice: navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 ? true : false,
    isATablet: navigator.userAgent.indexOf('Android') > -1 && navigator.userAgent.indexOf('Mobile') < 0 ? true : false,
    isPhoneDevice: false,
    isFirefox: (/firefox/gi).test(navigator.userAgent),
    isChrome: (/chrome/gi).test(navigator.userAgent),
    isSafari: (/safari/gi).test(navigator.userAgent),
    isSilk: (/silk/gi).test(navigator.userAgent),
    isIE: (/msie/gi).test(navigator.userAgent),
    isIE6: (/msie 6\./gi).test(navigator.appVersion),
    isIE7: (/msie 7\./gi).test(navigator.appVersion),
    isIE8: (/msie 8\./gi).test(navigator.appVersion),
    isIE9: (/msie 9\./gi).test(navigator.appVersion),
    isIE10: (/msie 10\./gi).test(navigator.appVersion),
    isIE11: (/trident/gi).test(navigator.appVersion),
    isIE7lt: (/msie 6\.|msie 7\./gi).test(navigator.appVersion),
    isIE8lt: (/msie 6\.|msie 7\.|msie 8\./gi).test(navigator.appVersion),
    isWin: (navigator.platform.indexOf('Win') != -1) ? true : false,
    isMac: (navigator.platform.indexOf('Mac') != -1) ? true : false
};
window.UA.isSP = (window.UA.isIPod === true || window.UA.isIPhone === true || window.UA.isADevice === true)? true: false;


/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/js/module/userAgent.js
 ** module id = 9
 ** module chunks = 0
 **/